import React from 'react';

const AppFooter = () => {
  return (
    <footer className="site-footer">
      <button className="back-to-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
        ↑
      </button>
    </footer>
  );
};

export default AppFooter;
